import { createHttpParams } from '../../../core/Http/HttpService';
import { apiSlice, apiParams } from '../../../store/Api';
import { Product, Application, Dealer } from '../Types';

export const invoiceApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanies: builder.query({
            query: () => apiParams.paths.companies
        }),
        getProducts: builder.query({
            query: () => apiParams.paths.products
        }),
        getDealers: builder.query({
            query: (params) => ({
                url: apiParams.paths.dealer.list,
                params: createHttpParams(params),
            }),
        }),
        getDealerInvoice: builder.mutation({
            query: (invoiceParams) => ({
                url: apiParams.paths.dealer.invoice,
                method: apiParams.methods.POST,
                body: invoiceParams,
            })
        }),
        generateExcel: builder.mutation({
            query: (generateParams) => ({
                url: apiParams.paths.invoice.generate,
                method: apiParams.methods.POST,
                body: generateParams,
            })
        }),
        summarySheet: builder.query({
            query: (params) => ({
                url: apiParams.paths.invoice.summary,
                params: createHttpParams(params),
            })
        }),
        marketSheet: builder.query({
            query: (params) => ({
                url: apiParams.paths.invoice.market,
                params: createHttpParams(params),
            })
        }),
        dealerSheet: builder.mutation({
            query: (params) => ({
                url: apiParams.paths.invoice.dealer,
                body: params,
                method: apiParams.methods.POST,
            })
        }),
        requestExcel: builder.mutation<Blob, {summaryData: string, marketData: string, dealerData: string}>({
            query: (excelParams) => ({
                url: apiParams.paths.invoice.excel,
                method: apiParams.methods.POST,
                body: excelParams,
                responseHandler: (response) => response.blob(),
            })
        }),
        prepare: builder.query({
            query: (params) => ({
                url: apiParams.paths.invoice.prepare,
                params: createHttpParams(params),
            })
        }),
        getDealerClasses: builder.query({
            query: () => apiParams.paths.dealerClasses,
        }),
        getCountries: builder.query({
            query: () => apiParams.paths.countries,
        }),
        getCurrencies: builder.query({
            query: () => apiParams.paths.currencies,
        }),
        getDistinctContractTypes: builder.query({
            query: () => apiParams.paths.contract.distinct,
        }),
    })
});

export const { 
	useGetCompaniesQuery,
	useGetCountriesQuery, 
	useGetCurrenciesQuery, 
	useGetDealerClassesQuery, 
	useGetProductsQuery,
	useLazyGetDealersQuery,
    useLazySummarySheetQuery,
    useLazyMarketSheetQuery,
    useDealerSheetMutation,
    useGenerateExcelMutation,
	useGetDealerInvoiceMutation,
	useGetDistinctContractTypesQuery,
    useLazyPrepareQuery,    
    useRequestExcelMutation,    
} = invoiceApiSlice;
